import { MessagingHelper } from "../helpers/MessagingHelper";
import { PaginatedList } from "../helpers/PaginatedList";
import { AuxiliaryEquipmentDTO } from "../models/AuxiliaryEquipment/AuxiliaryEquipmentDTO";
import { AuxiliaryEquipmentModelDTO } from "../models/AuxiliaryEquipment/AuxiliaryEquipmentModelDTO";
import { AuxiliaryEquipmentSearchResultDTO } from "../models/AuxiliaryEquipment/AuxiliaryEquipmentSearchResultDTO";
import { CreateAuxiliaryEquipmentDTO } from "../models/AuxiliaryEquipment/CreateAuxiliaryEquipmentDTO";
import { EditAuxiliaryEquipmentDTO } from "../models/AuxiliaryEquipment/EditAuxiliaryEquipmentDTO";
import { SearchAuxiliaryEquipmentByDescriptionDTO } from "../models/AuxiliaryEquipment/SearchAuxiliaryEquipmentByDescriptionDTO";
import { SearchAuxiliaryEquipmentByDescriptionResponseDTO } from "../models/AuxiliaryEquipment/SearchAuxiliaryEquipmentByDescriptionResponseDTO";
import { SearchAuxiliaryEquipmentByModelDTO } from "../models/AuxiliaryEquipment/SearchAuxiliaryEquipmentByModelDTO";
import { Parameter } from "../models/Parameter";
import { APIService } from "./APIService";

export class AuxiliaryEquipmentService {

    async GetAll(
        searchParameters: Parameter[],
        sortingParameters: Parameter[],
        currentPage: number,
        pageSize: number,
    ): Promise<PaginatedList<AuxiliaryEquipmentSearchResultDTO>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/AuxiliaryEquipment/GetAll`,
                {
                    searchParameters,
                    sortingParameters,
                    currentPage,
                    pageSize,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new PaginatedList<AuxiliaryEquipmentSearchResultDTO>(
                false,
                "Erro ao obter a informação dos equipamentos auxiliares",
                "",
                [],
                0,
            );
        }
    }

    async GetAuxiliaryEquipmentsByDescription(
        data: SearchAuxiliaryEquipmentByDescriptionDTO
    ): Promise<MessagingHelper<SearchAuxiliaryEquipmentByDescriptionResponseDTO[]>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/AuxiliaryEquipment/GetAuxiliaryEquipmentsByDescription`,
                {
                    ...data,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<SearchAuxiliaryEquipmentByDescriptionResponseDTO[]>(
                false,
                "Erro ao ligar ao servidor para obter os equipamentos auxiliares",
                []
            );
        }
    }

    async GetAuxiliaryEquipmentByErpId(erpId: string | undefined): Promise<MessagingHelper<AuxiliaryEquipmentDTO | null>> {
        try {
            var response = await APIService.Axios().get(
                `${APIService.GetURL()}/AuxiliaryEquipment/GetAuxiliaryEquipmentByErpId/${erpId}`,
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao obter a informação do equipamento auxiliar",
                null
            );
        }
    }

    async SearchAuxiliaryEquipmentByModel(
        searchParams: SearchAuxiliaryEquipmentByModelDTO,
    ): Promise<MessagingHelper<AuxiliaryEquipmentModelDTO[] | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/AuxiliaryEquipment/SearchByModel`,
                {
                    ...searchParams,
                },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                },
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<null>(
                false,
                "Erro ao ligar ao servidor para obter a informação dos modelos",
                null
            );
        }
    }

    async Edit(
        auxEquip: EditAuxiliaryEquipmentDTO
    ): Promise<MessagingHelper<AuxiliaryEquipmentDTO | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/AuxiliaryEquipment/EditAuxiliaryEquipment`,
                { ...auxEquip },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<AuxiliaryEquipmentDTO | null>(
                false,
                "Erro ao ligar ao servidor para atualizar a informação do equipamento auxiliar",
                null
            );
        }
    }

    async Create(
        auxEquip: CreateAuxiliaryEquipmentDTO
    ): Promise<MessagingHelper<number | null>> {
        try {
            var response = await APIService.Axios().post(
                `${APIService.GetURL()}/AuxiliaryEquipment/CreateAuxiliaryEquipment`,
                { ...auxEquip },
                {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + APIService.GetToken(),
                    },
                }
            );
            return response.data;
        } catch (error) {
            return new MessagingHelper<number | null>(
                false,
                "Erro ao ligar ao servidor para atualizar a informação do equipamento auxiliar",
                null
            );
        }
    }
}